export default "__VITE_ASSET__BHetZKeF__"